<div class="page-content">

      <div><button class="btn-back" title="{{'ORG_contact_information.back_alt'|translate}}" (click)="onPreviousClick()" translate>{{'button.prev'}}</button></div>

      <h1 class="page_title" translate>{{'ORG_contact_information.page_title'}}</h1>

      
      <h3 html='ORG_contact_information.mail'></h3>
      <div>
            <div class="sub-title" translate> {{'ORG_contact_information.mail_addr.office'}} </div>
            <div class="sub-title" translate> {{'ORG_contact_information.mail_addr.line1'}} </div>
            <div class="sub-title" translate> {{'ORG_contact_information.mail_addr.line2'}} </div>
            <div class="sub-title" translate> {{'ORG_contact_information.mail_addr.line3'}} </div>
      </div>
      
      <div class="padding-top">
            <h3 html='ORG_contact_information.call'></h3>
            <div class="sub-title" translate> {{'ORG_contact_information.call_info.tollfree_label'}} </div>
            <div class="sub-title" translate> {{'ORG_contact_information.call_info.tollfree_number'}} </div>
            <div class="label-header" translate> {{'ORG_contact_information.call_info.gta_intl_label'}} </div>
            <div class="sub-title" translate> {{'ORG_contact_information.call_info.gta_intl_number'}} </div>
            <div class="label-header" translate> {{'ORG_contact_information.call_info.tty_label'}} </div>
            <div class="sub-title" translate> {{'ORG_contact_information.call_info.tty_number1'}} </div>
            <div class="sub-title" translate> {{'ORG_contact_information.call_info.tty_number2'}} </div>
      </div>

      <div class="padding-top">
            <h3 html='ORG_contact_information.email'></h3>

            <div class="sub-title" html='ORG_contact_information.emailText'></div>

            <ng-input type="string" [(ng-model)]="userEmail" [(ng-error)]="error_email"
                  alt-text="ORG_contact_information.yourEmail_alt" size="28" max="256">{{'ORG_contact_information.yourEmail'}}
            </ng-input>
      
            <ng-select [item-list]="items.subjectList" [(ng-model)]="subject" [(ng-error)]="error_subject" 
                  label='ORG_contact_information.subject' size="17"></ng-select>
            
            <div html='ORG_contact_information.message'></div>

            <textarea [(ngModel)]="userMessage"  class="text-input"
                       title="{{'ORG_contact_information.message_alt'|translate}}" 
                      rows="12" [maxlength]="2000"
                      (keyup)="messageChanged()"></textarea>

            <errors [error]="error_message"></errors>

            <div class="padding-top padding-bottom">
                  <button class="btn-next btn-send" (click)="sendMessage();" alt-text="ORG_contact_information.sendBT_alt"
                        translate>{{'ORG_contact_information.sendBT'}}
                  </button>
            </div>

            <div [hidden]="submitted!=true || error_message!=''" html='ORG_contact_information.sent'></div>
            <errors [error]="error_sent"></errors>
      </div>
      
</div>